import React from 'react';
import styled from 'styled-components';
import { PropTypes } from 'prop-types';

import { OptionPropType } from '@components/basting-selector/prop-types';
import { Box } from '../../../grid';
import { Image } from '../../../image';
import { Placeholder } from '../placeholder';

const StyledImage = styled(Image)`
  transition: 350ms ease-out;
  border-radius: ${({ $isDrink }) => ($isDrink ? '8px' : '16px')};
  object-fit: cover;

  button:not(:disabled):hover & {
    transform: scale(1.05);
  }
`;

const Container = styled.div`
  display: block;
  position: relative;
  overflow: hidden;
  border-radius: ${({ $isDrink }) => ($isDrink ? '8px' : '16px')};
  aspect-ratio: 1 / 1;
  box-sizing: content-box;
  border: ${({ selected }) => (selected ? '2px solid black' : '2px solid transparent')};

  ${({ selected, theme }) => selected && `color: ${theme.colors.black};`}
`;

export const OptionImage = ({ option, selected, width, height, isDrink }) => {
  return (
    <Container selected={selected} disabled={option?.disabled} $isDrink={isDrink}>
      {option?.disabled && (
        <Box zIndex="1" backgroundColor="grey30" position="absolute" width="100%" height="100%" opacity="0.4" />
      )}
      {option.image ? (
        <StyledImage width={width} height={height} src={option.image} loading="lazy" opacity={0.5} $isDrink={isDrink} />
      ) : (
        <Box
          display="flex"
          width="100%"
          height="100%"
          backgroundColor="#B1F5EB"
          justifyContent="center"
          alignItems="center"
        >
          <Placeholder />
        </Box>
      )}
    </Container>
  );
};

OptionImage.propTypes = {
  option: OptionPropType.isRequired,
  selected: PropTypes.bool.isRequired,
  width: PropTypes.number,
  height: PropTypes.number,
  isDrink: PropTypes.bool,
};

OptionImage.defaultProps = {
  width: '100%',
  height: undefined,
  isDrink: false,
};
